import React from "react";
import { Heart, ChevronRight, LogIn } from "lucide-react";
import { useSite } from "../context/SiteContext";
import { CrownIcon, LipsIcon, InstaGradientIcon } from "./Icons";

const CTA = ({ variant, icon, title, sub, onClick, testid }) => (
  <button onClick={onClick} data-testid={testid} className={`cta cta-${variant}`}>
    <span className="cta-icon">{icon}</span>
    <span className="flex-1 min-w-0 text-left">
      <span className="block text-[17px] sm:text-[20px] font-semibold leading-tight">{title}</span>
      <span className="block text-[12.5px] sm:text-[13px] mt-1 leading-snug opacity-90 sm:whitespace-nowrap">{sub}</span>
    </span>
    <ChevronRight className="w-5 h-5 sm:w-6 sm:h-6 shrink-0 cta-chev" />
  </button>
);

export default function Hero({ onLogin, onVip, onFollow }) {
  const { img } = useSite();
  const bg = img("hero", "/img/hero_clean.jpg");
  return (
    <section id="home" className="hero relative overflow-hidden">
      <div className="absolute inset-0 hero-bg" style={{ backgroundImage: bg ? `url(${bg})` : "none" }} data-testid="hero-bg" />
      <div className="absolute inset-0 hero-shade" />
      <div className="relative max-w-[1024px] mx-auto px-6 lg:px-0 lg:pl-[64px] pt-[400px] md:pt-[126px] pb-[40px] md:pb-[44px]">
        <div className="max-w-[440px] fade-up">
          <p className="text-[12px] sm:text-[14px] tracking-[0.02em] text-white/85 uppercase">Your favourite girl from Bangalore</p>
          <h1 className="hero-title mt-4">
            <span className="text-white">Meet Maya —</span><br />
            <span className="text-[#f47aa8]">Your Fav Girl from Bangalore <Heart className="inline w-[28px] h-[28px] sm:w-[38px] sm:h-[38px] -mt-2 sm:-mt-3" strokeWidth={2} /></span>
          </h1>
          <p className="mt-4 sm:mt-5 text-[16px] sm:text-[20px] leading-[1.45] text-white/95">
            Flirty chats, real vibes, exclusive content…<br className="hidden sm:block" /> Welcome to my world <LipsIcon className="inline w-6 h-4 ml-1 -mt-1" />
          </p>
          <div className="mt-5 flex flex-col gap-3 sm:gap-[15px] max-w-[402px]">
            <CTA variant="pink" testid="cta-signin" onClick={onLogin}
              icon={<LogIn className="w-[30px] h-[30px] sm:w-[38px] sm:h-[38px]" strokeWidth={1.8} />}
              title="Already a member?" sub="Sign in" />
            <CTA variant="outline" testid="cta-vip" onClick={onVip}
              icon={<CrownIcon className="w-[30px] h-[30px] sm:w-[38px] sm:h-[38px] text-[#f45d8f]" />}
              title="Maya VIP – ₹499/month" sub="Exclusive content, priority replies & more" />
            <CTA variant="glass" testid="cta-follow" onClick={onFollow}
              icon={<InstaGradientIcon className="w-[34px] h-[34px] sm:w-[42px] sm:h-[42px]" />}
              title="Follow Maya" sub="On Instagram" />
          </div>
        </div>
      </div>
    </section>
  );
}
